<template></template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
    computed: mapState(['braintreeEnvironment', 'defaultPaymentMethod']),

    mounted() {
        const refreshTimestamp = Number(new Date()) + 21600000; // 21600000 = 6hrs.

        setInterval(async () => {
            if (refreshTimestamp > Number(new Date())) {
                return;
            }

            const type = this.defaultPaymentMethod === 'null' ? 'checkout' : 'immediate';

            await axios.post(
                `https://admin.iphonephotographyschool.com/api/counter/${this.braintreeEnvironment}_sales_page_reload_${type}`,
            );

            location.reload();
        }, 5000);
    },
};
</script>
